import { CommonModule } from '@angular/common';
import { AfterViewInit, Component, ElementRef, HostListener, Input, OnChanges, OnInit, output, SimpleChanges, ViewChild } from '@angular/core';
import { LayoutConfigService } from 'src/app/shared/services/layout-config.service';
import { CarouselItem } from './carousel-plans.model';
import { CarouselPlanCardComponent } from "./carousel-plan-card/carousel-plan-card.component";

@Component({
  selector: 'app-carousel-plans',
  standalone: true,
  imports: [CommonModule, CarouselPlanCardComponent],
  templateUrl: './carousel-plans.component.html',
  styleUrl: './carousel-plans.component.scss'
})
export class CarouselPlansComponent implements OnInit, OnChanges, AfterViewInit {

  @ViewChild('carousel', { read: ElementRef }) carousel: ElementRef;
  @Input() items: CarouselItem[];
  @Input() styles: any;
  @Input() highlightButtonOptions: any;
  @Input() defaultButtonOptions: any;

  carouselResponse = output<CarouselItem>();

  chunkedItems: CarouselItem[][] = [];
  chunkSize = 4;
  isMobile = false;
  showIndicators = false;
  classes: any;
  classesAlign: any;
  versaoAtual: any;

  constructor(
    private layoutConfigService: LayoutConfigService,
    private elRef: ElementRef
  ) { }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['items'] && this.items?.length) {
      this.chunkItems();
    }
  }

  ngOnInit(): void {
    const layoutVersion = this.layoutConfigService.getLayoutVersion();
    this.classes = {
      'layout-v2': layoutVersion === 2,
    };
    this.classesAlign = {
      'align-items-center': layoutVersion === 1,
      'align-items-start': layoutVersion === 2
    };
    this.setCardSize(window.innerWidth);
    this.versaoAtual = layoutVersion;

    this.chunkItems();
  }

  ngAfterViewInit() {
    setTimeout(() => this.equalizeHeights(), 50);
  }

  @HostListener('window:resize', ['$event'])
  onResize(event: Event) {
    this.setCardSize((event.target as Window).innerWidth);
    this.chunkItems();

    clearTimeout((this as any)._resizeTimer);
    (this as any)._resizeTimer = setTimeout(() => this.equalizeHeights(), 100);
  }

  private equalizeHeights() {
    const carouselEl: HTMLElement | null = this.elRef.nativeElement.querySelector('#carouselExampleIndicators');
    if (!carouselEl) return;

    // pega todos os slides (carousel-item)
    const slides = Array.from(carouselEl.querySelectorAll<HTMLElement>('.carousel-item'));
    if (!slides.length) return;

    slides.forEach(slide => {
      // Seleciona os cards dentro do slide
      const cards = slide.querySelectorAll('.card-default') as NodeListOf<HTMLElement>;
      if (!cards.length) return;

      // Remove qualquer altura previamente aplicada
      cards.forEach(c => {
        c.style.height = '';
        c.style.minHeight = '';
      });

      // Calcula a altura real de cada card
      const heights = Array.from(cards).map(c => c.offsetHeight);
      const max = Math.max(...heights);

      // Ajusta todos os cards e o slide com base no maior card
      cards.forEach(c => {
        const computed = window.getComputedStyle(c);
        const cssMinHeight = parseFloat(computed.minHeight) || 0;
        const finalHeight = Math.max(max, cssMinHeight);
        c.style.minHeight = `${finalHeight}px`;
      });

      // Ajusta também o container do slide para acompanhar
      const slideComputed = window.getComputedStyle(slide);
      const slideMinHeight = parseFloat(slideComputed.minHeight) || 0;
      const slideFinalHeight = Math.max(max, slideMinHeight);
      slide.style.minHeight = `${slideFinalHeight}px`;
    });
  }

  setButtonConfig() {
    this.items.forEach(item => {
      if (item.highlight) {
        item.buttonOptions = this.highlightButtonOptions;
      } else {
        item.buttonOptions = this.defaultButtonOptions;
      }
    });
  }

  setCardSize(innerWidth: number) {
    this.isMobile = false;
    switch (true) {
      case innerWidth < 768:
        this.chunkSize = 1;
        this.isMobile = true;
        break;
      case innerWidth >= 768 && innerWidth < 990:
        this.chunkSize = 2;

        break;
      case innerWidth >= 990 && innerWidth < 1200:
        this.chunkSize = 3
        break;
      case innerWidth >= 1200:
        this.chunkSize = 4
        break;

      default:
        break;
    }
  }

  private chunkItems(): void {
    this.chunkedItems = [];

    for (let i = 0; i < this.items.length; i += this.chunkSize) {
      const chunkedCarouselItems = this.items.slice(i, i + this.chunkSize);
      this.chunkedItems.push(chunkedCarouselItems);
    }
    this.showIndicators = this.chunkedItems.length > 1;

  }

  btnCarouselAction(plano: CarouselItem) {
    this.carouselResponse.emit(plano);
  }
}
